"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createAvatarStyle;

function createAvatarStyle(_ref) {
  var avatarBorderRadius = _ref.avatarBorderRadius,
      avatarSize = _ref.avatarSize;
  return {
    '&.webchat__defaultAvatar': {
      borderRadius: avatarBorderRadius,
      height: avatarSize,
      width: avatarSize
    }
  };
}